import { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setServiceComboItemsPop } from "../../store/api/Modals";

const ButtonLabel = (props) => {
    const { findSetting, index, setSettings } = props;
    const [items, setItems] = useState('');
    const dispatch = useDispatch();
    const setValue = (value) => {
        setItems(value);
        setSettings(value, index);
    }
    const showItems = (items) => {
        dispatch(setServiceComboItemsPop({ show: true, items: items, setValue: setValue }));
    }
    return (
        <Fragment>
            <Button className="group-Btn-smalll" onClick={() => showItems(findSetting("Services_ComboBoxExtAttr" + index + "_Items"))}>ویرایش لیست</Button>
            &nbsp;
            <label style={{ color: "#ff006f" }}>{items && items.length > 0 ? items : findSetting("Services_ComboBoxExtAttr" + index + "_Items")}</label>
        </Fragment>
    );
}
export default ButtonLabel;